import { render } from "./GalleryModalComponent.vue?vue&type=template&id=3700cd20&scoped=true"
const script = {}

import "./GalleryModalComponent.vue?vue&type=style&index=0&id=3700cd20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3700cd20"]])

export default __exports__